import { useState } from 'react';
import { Outlet, useLocation, useParams } from 'react-router-dom';
import { UiModeProvider } from '@/contexts/UiModeContext';
import TopHeader from '@/components/layout/TopHeader';
import SecondarySubNav from '@/components/layout/SecondarySubNav';
import Footer from '@/components/layout/Footer';
import PrimarySidebar from '@/components/layout/PrimarySidebar';
import SudoBanner from '@/components/admin/SudoBanner';
import TrialBanner from '@/components/TrialBanner';
import { getSubNavConfig } from '@/config/subNavConfig';

export default function AppLayout() {
  const [mobileNavOpen, setMobileNavOpen] = useState(false);
  const location = useLocation();
  const { caseId } = useParams<{ caseId?: string }>();

  // Get sub-navigation configuration for current route
  const subNavConfig = getSubNavConfig(location.pathname, caseId);

  return (
    <UiModeProvider>
      <div className="flex min-h-screen flex-col bg-transparent" data-testid="authed-layout" data-app-shell="true">
        {/* Auth sentinel: Present on all authenticated routes for audit harness */}
        <div data-testid="authed-nav" className="hidden" aria-hidden="true" />
        {/* T-48: Sudo session banner (visible when admin is impersonating a user) */}
        <SudoBanner />
        {/* Trial countdown banner (visible only while subscriptionStatus === 'trialing') */}
        <TrialBanner />
        {/* Top Header */}
        <TopHeader onMobileMenuToggle={() => setMobileNavOpen(v => !v)} />

        {/* Main Layout with Sidebar */}
        <div className="flex flex-1 min-h-0">
          {/* Primary Sidebar */}
          <PrimarySidebar
            mobileOpen={mobileNavOpen}
            onMobileClose={() => setMobileNavOpen(false)}
          />

          {/* Content Area */}
          <div className="flex flex-1 flex-col min-w-0">
            {/* Secondary Sub-Navigation */}
            <SecondarySubNav config={subNavConfig} />

            {/* Page Content (Scrollable) — responsive padding */}
            <main className="flex-1 overflow-y-auto bg-transparent px-4 py-4 sm:px-6 sm:py-6">
              <Outlet />
            </main>

            {/* Footer */}
            <Footer />
          </div>
        </div>
      </div>
    </UiModeProvider>
  );
}
